module.exports = __webpack_public_path__ + "img/vote_example_score.4d816d64.jpg";